Core.TimebankRouter = Core.SubRouter.extend({
    routes: {
        '': 'timebank',
        ':id': 'viewTimebank',
    },

    timebank: function () {
      app.setMainView(new TimeBankView({scrolling: true}), 'directory');
    },

    viewTimebank: function (id) {
        console.log('id:',id);
        var tb = new TimeBank({id: id});
        tb.fetch().done(function(item){
            console.log('customerId',item.customerId);
            console.log(item);
            var reports = new WorkReports([],{});
            reports.filterParams.path = 'customer/' + item.customerId;
            view = new TimeBankView({
                collection: reports,
                parentView: this,
                timebank: tb,
                customerId: item.customerId,
            });
            app.setMainView(view,'directory');//$('#timebank-div').append(view.render().$el);
        })

        //var timebank = new TimeBank({id:id});
        //timebank.fetch();
        //var reports = new WorkReports([],{});
        //reports.filterParams.path = 'customer/' + timebank.customerId;

        //var view = new TimeBankView({timebank:timebank,collection: reports});

        //view.timebank = new TimeBank({id:id});
        //view.collection.filterParams.path = 'timebank/' + id;
        //view.timebank.fetch();//this.fetchList('customer/'+id); },
        //app.setMainView(view, 'directory');
    },


});
